import React from "react";

const Block = ({ className = "", ...rest }) => (
    <div className={`bg-brand-panel rounded animate-pulse ${className}`} {...rest} />
);

const ResultsSkeleton = () => {
    return (
        <>
            <section className="rounded-3xl bg-white border border-brand-panel shadow-brand overflow-hidden">
                <div className="p-8 sm:p-12 lg:p-14">
                    <Block className="h-3 w-44" />
                    <div className="mt-4">
                        <Block className="h-20 sm:h-28 lg:h-32 w-2/3 sm:w-1/2" />
                    </div>
                    <Block className="mt-4 h-3 w-56" />
                </div>
            </section>

            <section className="mt-14 sm:mt-16">
                <div className="mb-5 sm:mb-6">
                    <Block className="h-3 w-32 mb-3" />
                    <Block className="h-7 sm:h-8 w-40" />
                    <Block className="mt-3 h-3 w-3/4 max-w-xl" />
                </div>
                <div className="rounded-2xl bg-white border border-brand-panel shadow-brand overflow-hidden divide-y divide-brand-panel">
                    {[0, 1, 2, 3, 4].map((i) => (
                        <div key={i} className="flex items-center gap-4 p-5">
                            <Block className="h-5 w-8" />
                            <div className="flex-1">
                                <Block className="h-4 w-40 mb-2" />
                                <Block className="h-3 w-24" />
                            </div>
                            <Block className="h-6 w-10" />
                        </div>
                    ))}
                </div>
            </section>

            <section className="mt-14 sm:mt-16">
                <div className="mb-5 sm:mb-6">
                    <Block className="h-3 w-28 mb-3" />
                    <Block className="h-7 sm:h-8 w-52" />
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 sm:gap-6">
                    {[0, 1].map((col) => (
                        <div key={col} className="rounded-2xl bg-white border border-brand-panel p-6 sm:p-7 shadow-brand">
                            <Block className="h-5 w-28 mb-5" />
                            <div className="space-y-4">
                                {[0, 1, 2, 3, 4].map((i) => (
                                    <div key={i}>
                                        <div className="flex items-baseline justify-between mb-1.5">
                                            <Block className="h-3 w-32" />
                                            <Block className="h-3 w-8" />
                                        </div>
                                        <Block className="h-1.5 w-full" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
};

export default ResultsSkeleton;
